import React from 'react';
import styled from 'styled-components';
import { SelectionTitle } from '../../../Styles';

const Wrapper = styled.div`
  margin-top: 35px;
  padding: 0 25px;
  .assembly-container {
    margin-top: 10px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 15px;
  }

  .title-icon-container {
    display: flex;
    align-items: center;
  }

  .desc-title {
    margin-bottom: 8px;
  }

  .tooltip-container {
    position: relative;
    margin-left: 8px;
    .tooltip-customize {
      right: -5px;
      left: unset;
      width: 216px;

      .tooltip-arrow {
        right: 5px;
        left: unset;
      }

      .desc {
        text-align: start;
      }
    }
    &:hover {
      .tooltip-customize {
        transform: scale(1);
      }
    }
  }
`;

function WallpaperType({
  wallpaperTypeId,
  productData,
  setProductVar,
  setChangeFeaturedFabrics
}) {
  const linkedFabricId = productData.fabric?.linkedFabric?.id;
  const fabricId = productData.fabric?.id;

  const fabricIdToQuery = linkedFabricId ? linkedFabricId : fabricId;

  const handleProductVar = wallpaperType => {
    setProductVar({
      fabric_id: fabricIdToQuery,
      frame_id: productData.frame.id,
      //render property / value if the size is not null
      ...(productData.frame.size !== null && {
        size_id: productData.frame.size.id
      }),
      //render property / value if the leg is not null
      ...(productData.leg && {
        leg_id: productData.leg.id
      }),
      ...(productData.frame.firmness && {
        firmness_id: productData.frame.firmness.id
      }),
      ...(productData.casterLeg && {
        caster_leg_id: productData.casterLeg.id
      }),
      ...(productData.frame.orientation !== null && {
        orientation: productData.frame.orientation
      }),
      ...(productData.frame.has_assembly_options && {
        is_assembled: productData.is_assembled
      }),
      ...(productData.frame.has_set_of_two && {
        supplier_quantity: productData.supplier_quantity
      }),
      wallpaper_type: wallpaperType
    });

    setChangeFeaturedFabrics(true);
  };

  return (
    <Wrapper>
      <div className="title-icon-container">
        <SelectionTitle>Wallpaper Type</SelectionTitle>
        {/* <div className="tooltip-container">
          <Icon icon="ti-tooltip-info" size={25} color="black" />
          <Tooltip className="tooltip-customize">
            <div className="tooltip-arrow" />

            <div className="desc">
              <SubtitleThree className="desc-title" bold={true}>
                PEEL & STICK
              </SubtitleThree>
              <BodyFour>
                Our Peel & Stick wallpaper is [lorem ipsum dolor sit amet,
                consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                labore et dolore magna aliqua.]
              </BodyFour>

              <SubtitleThree className="desc-title" bold={true}>
                Traditional
              </SubtitleThree>
              <BodyFour>
                Our Peel & Stick wallpaper is [lorem ipsum dolor sit amet,
                consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                labore et dolore magna aliqua.]
              </BodyFour>
            </div>
          </Tooltip>
        </div> */}
      </div>
      <div className="assembly-container">
        {wallpaperTypeData.map(wallpaperType => {
          return (
            <WallpaperTypeButton
              disabled={wallpaperTypeId != wallpaperType.id && !linkedFabricId}
              key={wallpaperType.id}
              selected={wallpaperTypeId === wallpaperType.id}
              onClick={() => {
                if (wallpaperTypeId === wallpaperType.id) return;
                handleProductVar(wallpaperType.id);
              }}
            >
              {wallpaperType.name}
            </WallpaperTypeButton>
          );
        })}
      </div>
    </Wrapper>
  );
}

export default WallpaperType;

const WallpaperTypeButton = styled.button`
  border: ${({ selected, disabled }) =>
    selected
      ? '3px solid #2A5CAF'
      : disabled
      ? '1px solid #C4C4C4'
      : '1px solid black;'};
  height: 50px;
  width: 100%;
  background: ${({ disabled }) => (disabled ? '#EBEBEB' : 'white')};
  color: ${({ disabled }) => (disabled ? '#8D8D8D' : 'black')};
`;

const wallpaperTypeData = [
  {
    id: 'peel_and_stick',
    name: `Peel + Stick`
  },
  {
    id: 'traditional',
    name: `Traditional`
  }
];
